<ridango-block-full-width [isEmpty]="groups?.length === 0" role="radiogroup" aria-labelledby="product_length_title">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_length_title_1">
        {{ 'CHOOSE_GROUP' | translate }}
    </h2>
    <ridango-block-items-three *ngIf="groups?.length !== 0" ridangoMatchHeight="btn--big-selection__top-wrapper">
        <ridango-selectable-checkable-item
            *ngFor="let group of groups; first as isFirst"
            [item]="group"
            [selected]="group.id === groupSelected?.id"
            [tabIndex]="getTabIndex(group)"
            (onItemSelected)="selectGroup($event)"
            (onMovedLeft)="selectLeft($event)"
            (onMovedRight)="selectRight($event)"
            (onFocused)="focus($event)"
            (onBlurred)="blur($event)"></ridango-selectable-checkable-item>
    </ridango-block-items-three>
</ridango-block-full-width>
